
const newModel = () => {
    return {
        thethaoPhongtraoId: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        tenPhuongXa: null,
        phuongXaId: null,
        soNguoiLuyenTap: null,
        tyLeNguoiLuyentap: null,
        soGiaDinhTheThao: null,
        tyLeGiaDinhTheThao: null,
        soClbTdtt: null,
        soLopPhoCapBoi: null,
        soTreEmPhoCapBoi: null,
        dangCaiGiaiQuocGia: null,
        dangCaiGiaiKhuVuc: null,
        idKy: null,
        tenKy: null,
        ghiChu: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoPhongtraoId: null,
        quanHuyenId: null,
        phuongXaId: null,
        soNguoiLuyenTap: null,
        tyLeNguoiLuyentap: null,
        soGiaDinhTheThao: null,
        tyLeGiaDinhTheThao: null,
        soClbTdtt: null,
        soLopPhoCapBoi: null,
        soTreEmPhoCapBoi: null,
        dangCaiGiaiQuocGia: null,
        dangCaiGiaiKhuVuc: null,
        idKy: null,
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoPhongtraoId: item.thethaoPhongtraoId,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        soNguoiLuyenTap: item.soNguoiLuyenTap,
        tyLeNguoiLuyentap: item.tyLeNguoiLuyentap,
        soGiaDinhTheThao: item.soGiaDinhTheThao,
        tyLeGiaDinhTheThao: item.tyLeGiaDinhTheThao,
        soClbTdtt: item.soClbTdtt,
        soLopPhoCapBoi: item.soLopPhoCapBoi,
        soTreEmPhoCapBoi: item.soTreEmPhoCapBoi,
        dangCaiGiaiQuocGia: item.dangCaiGiaiQuocGia,
        dangCaiGiaiKhuVuc: item.dangCaiGiaiKhuVuc,
        idKy: item.idKy,
        tenKy: item.tenKy,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoPhongtraoId: item.thethaoPhongtraoId,
        quanHuyenId: item.quanHuyenId,
        phuongXaId: item.phuongXaId,
        soNguoiLuyenTap: item.soNguoiLuyenTap,
        tyLeNguoiLuyentap: item.tyLeNguoiLuyentap,
        soGiaDinhTheThao: item.soGiaDinhTheThao,
        tyLeGiaDinhTheThao: item.tyLeGiaDinhTheThao,
        soClbTdtt: item.soClbTdtt,
        soLopPhoCapBoi: item.soLopPhoCapBoi,
        soTreEmPhoCapBoi: item.soTreEmPhoCapBoi,
        dangCaiGiaiQuocGia: item.dangCaiGiaiQuocGia,
        dangCaiGiaiKhuVuc: item.dangCaiGiaiKhuVuc,
        idKy: item.idKy,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const errors = () => {
    return {
        thethaoPhongtraoId: null,
        quanHuyenId: null,
        phuongXaId: null,
        soNguoiLuyenTap: null,
        tyLeNguoiLuyentap: null,
        soGiaDinhTheThao: null,
        tyLeGiaDinhTheThao: null,
        soClbTdtt: null,
        soLopPhoCapBoi: null,
        soTreEmPhoCapBoi: null,
        dangCaiGiaiQuocGia: null,
        dangCaiGiaiKhuVuc: null,
        idKy: null,
        ghiChu: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        idKy: null,
        phuongXaId: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        idKy: null,
        phuongXaId: null,
        enabled: null,
    }
}

export const phongTraoTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


